export default __webpack_public_path__ + "static/media/undraw_QA.f5a904f3.svg";